import script from "./InvoiceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceContent.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceContent.vue?vue&type=style&index=0&id=289ddf30&lang=css"

const __exports__ = script;

export default __exports__